module.exports = __webpack_public_path__ + "static/media/css.b1b2685a.svg";